import SongParts from './SongParts';

export default SongParts;
